// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__9-u5e"};